<button tpl-button class="sign-out-button" color="basic" icon="sign-out" buttonType="filled" width="full">
  <span class="sign-out-button-label">ログアウト</span>
</button>
